import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { StrappiService } from 'src/app/services/strappi.service';
import { Endpoints } from 'src/environments/endpoints';

@Component({
  selector: 'app-landing-credito',
  templateUrl: './landing-credito.component.html',
  styleUrls: ['./landing-credito.component.scss', '../landing-leasing/landing-leasing.component.scss']
})
export class LandingCreditoComponent implements OnInit {
  @ViewChild('asesoria') asesoria!: ElementRef
  feature = 0
  intervaloSub: Subscription | undefined 
  basePath:string = Endpoints.strappi.base

  banner: any = null
  bannerBeneficios: any = null
  bannerRequisitos: any = null 
  
  destacado1: any = null
  destacado2: any = null
  destacado3: any = null

  constructor(private strapi: StrappiService) { }

  ngOnInit(): void {
    //Animación requisitos
    this.intervaloSub = interval(2000).subscribe(() => {
      if (this.feature === 3) {
        this.feature = 0
      } else {
        this.feature++
      }
    })
    //Obtenemos las imagenes
    this.strapi.getLandingBanners().subscribe(value  => {
      this.getImages(value)
    })
  }

  /**
   * Obtenemos las imagenes y las formateamos para mostrarlas 
   * @param value 
   */
  getImages(value: any): void {
    if (value) {
      const items = value.landing_credito ? value.landing_credito : null  
      if (items) {
        console.log(items, value)
        const banner = items.find((i: any) => i.tipo && i.tipo.includes("Crédito"))
        const bannerCaracteristicas = items.find((i: any) => i.tipo && i.tipo === "beneficios")
        const bannerRequisitos = items.find((i: any) => i.tipo && i.tipo === "requisitos")
        const destacado1 = items.find((i: any) => i.tipo && i.tipo === "destacado_1")
        const destacado2 = items.find((i: any) => i.tipo && i.tipo === "destacado_2")
        const destacado3 = items.find((i: any) => i.tipo && i.tipo === "destacado_3")

        this.banner = banner ? this.formatBanner(banner) : null
        this.bannerBeneficios = bannerCaracteristicas ? this.formatImg(bannerCaracteristicas) : null
        this.bannerRequisitos = bannerRequisitos ? this.formatImg(bannerRequisitos) : null
        this.destacado1 = destacado1 ? this.formatBanner(destacado1) : null
        this.destacado2 = destacado2 ? this.formatBanner(destacado2) : null
        this.destacado3 = destacado3 ? this.formatBanner(destacado3) : null

      }
    }
  }


  /**
   * Formateamos banner principal
   * @param value 
   * @returns 
   */
  formatBanner(value:any):any {
    const clone = JSON.parse(JSON.stringify(value))

    if (value.image) {
      clone.image = this.formatImg(value)
    }

    return clone;    
  }

  /**
   * Formateamos imagenes
   * @param img 
   * @returns 
   */
  formatImg(img: any): any {
    let formated = img
    const image = img.image && img.image.length > 0 ? img.image[0] : null
    if (image) {
      formated = {
        ...image,
        src: this.basePath + image.url
      }
    }
    return formated
  }

  /**
   * Cancelamos la animación
   */
  ngOnDestroy(): void {
    if (this.intervaloSub) {
      this.intervaloSub.unsubscribe()
    }
  }

  /**
   * Scroll a formulario
   */
  scrollToForm(): void {
    this.asesoria.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start'
    })
  }


}
